export const voice = {
  name: 'voice',
  title: 'voice.breadcrumb.title',
  icon: () => import('@shared/components/icon/sidebar/icon-voice.vue'),
  route: { name: 'voice.index' },
  children: [
    {
      title: 'voice.breadcrumb.trunk.index',
      route: { name: 'voice.trunk.index' }
    },
    {
      title: 'shared.breadcrumb.stats.title',
      route: { name: 'voice.stats.type', params: { type: 'general' } }
    }
  ]
};
